<script setup lang="ts">
import type { IconName } from '@ui/components/icon/types'
import { useDropdown } from '@ui/components/dropdown/useDropdown'
import { Placements } from '@ui/utils/placements'

withDefaults(
  defineProps<{
    label?: string
    icon?: IconName
    size?: ButtonSizes
    variant?: ButtonVariant
    dropdownWidth?: number
    offset?: number
    padding?: boolean
    placements?: Placements[]
  }>(),
  {
    label: '',
    size: Sizes.HanSolo,
    variant: ButtonVariant.Ghost,
    dropdownWidth: 235,
    offset: 18,
    padding: false,
    placements: () => [Placements.BottomEnd],
  },
)

defineSlots<{
  default?: (props: { close: () => void }) => void
}>()

const reference = ref()
const ignore = [reference]
const { show, placement, toggle, close } = useDropdown()
</script>

<template lang="pug">
UiIconButton(v-if="icon" ref="reference" :size="size" :name="icon" :variant="variant" @click="toggle")
UiButton.w-40(v-else ref="reference" :size="size" :variant="variant" @click="toggle")
  .flex-center-center {{ label }}
UiDropdown(
  v-model:show="show"
  v-model:placement="placement"
  :style="{ width: `${dropdownWidth}px` }"
  :placements="placements"
  :reference="reference"
  :padding="padding"
  :offset="offset"
  :ignore="ignore"
)
  slot(:close="close")
</template>
